export const validation = {
  headingMaxChar: 30,
  paragraphMaxChar: 30,
  title: { required: true }
}
